import { COBURG } from "./propertyCoburg";
import { AINTREE } from "./propertyAintree";

// Central registry — display order on home page + /our-homes pinned cards.
export const PROPERTIES = [COBURG, AINTREE];

export const PROPERTY_BY_SLUG = Object.fromEntries(PROPERTIES.map((p) => [p.slug, p]));

export const FEATURED_PROPERTY = COBURG; // hero highlight on homepage

export function statusBadge(p) {
  if (p.status === "available") return { label: "Available now", tone: "green" };
  if (p.status === "upcoming") return { label: "Coming soon", tone: "purple" };
  return { label: "Filled", tone: "neutral" };
}
